import classNames from 'classnames';
import * as React from 'react';
import styles from './FilterSection.module.sass';
import { IconName } from '@blueprintjs/icons';
import { Icon, Intent } from '@blueprintjs/core';

export interface FilterOptionData {
  label: string;
  value: any;
  hasDivider?: boolean;
}

export interface FilterOptionWithIconData extends FilterOptionData {
  icon: IconName;
  intent?: Intent;
}

const isOptionWithIcon = (
  data: FilterOptionData
): data is FilterOptionWithIconData => Object.hasOwn(data, 'icon');

interface FilterOptionProps {
  option: FilterOptionData;
  isSelected: boolean;
  showIcon?: boolean;
  onClick: () => void;
}

/**
 * Basic filter option component - renders a simple clickable list item.
 */
export const FilterOption: React.FC<FilterOptionProps> = ({
  option,
  isSelected,
  onClick,
}) => {
  return (
    <>
      <div
        className={classNames(
          isOptionWithIcon(option) ? styles.listItemWithIcon : styles.listItem,
          {
            [styles.selected]: isSelected,
          }
        )}
        onClick={onClick}
      >
        <span>{option.label}</span>
        {isOptionWithIcon(option) && (
          <Icon icon={option.icon} intent={option.intent} />
        )}
      </div>
      {option.hasDivider && <div className={styles.divider} />}
    </>
  );
};
